/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Add_To_GalleryInputs */

const cs_property_ai_add_to_gallery = /** @type {(inputs: Property_Ai_Add_To_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat do veřejných fotek`)
};

const en_property_ai_add_to_gallery = /** @type {(inputs: Property_Ai_Add_To_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to public photos`)
};

/**
* | output |
* | --- |
* | "Add to public photos" |
*
* @param {Property_Ai_Add_To_GalleryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_add_to_gallery = /** @type {((inputs?: Property_Ai_Add_To_GalleryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Add_To_GalleryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_add_to_gallery(inputs)
	return cs_property_ai_add_to_gallery(inputs)
});